interface PromiseWithResolversResult<T>
{
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: unknown) => void;
}

interface PromiseConstructor
{
    withResolvers?<T>(): PromiseWithResolversResult<T>;
}

if (!Promise.withResolvers)
{
    Promise.withResolvers = function <T>()
    {
        let resolve: (value: T | PromiseLike<T>) => void;
        let reject: (reason?: unknown) => void;
        const promise = new Promise<T>(function (promiseResolve, promiseReject)
        {
            resolve = promiseResolve;
            reject = promiseReject;
        });

        return { promise, resolve: resolve!, reject: reject! };
    };
}
